import { DefaultModel } from '../../core/framework/default.model';
import { Questao } from '../questao/model/questao.model';
import { OpcaoResposta } from './opcao-resposta.model';

export class Resposta extends DefaultModel {

  questao: Questao;
  descricao: string;
  valor: any;
  opcoes?: OpcaoResposta[];

  constructor() {
    super();
    this.opcoes = [];
    this.descricao = '';
  }
}
